import React, { useCallback, useState } from 'react';

import { MentionEntityTypeEnum } from '@/types/schema';

import GroupList from './components/GroupList';
import MentionEntityList from './components/MentionEntityList';
import { MentionsData, MentionsProps } from './types';

function Mentions(props: MentionsProps) {
  const { focusEditor, defaultView, MentionsFactory } = props;
  const [initailMentions, setInitialMentions] = useState<MentionsData>();
  const [view, setView] = useState<MentionEntityTypeEnum | null>(defaultView || null);

  const changeView = useCallback(
    (viewType: MentionEntityTypeEnum) => {
      setView(viewType);
      focusEditor();
    },
    [focusEditor],
  );

  if (!view) {
    return <GroupList {...props} setInitialMentions={setInitialMentions} setView={changeView} />;
  }

  if (view === MentionEntityTypeEnum.Group) {
    return null;
  }

  const { BaseItem, getInitialItems, getMentionNodeAttrs, useSearch } = MentionsFactory[view]!;

  return (
    <MentionEntityList<any>
      {...props}
      BaseItem={BaseItem}
      getMentionNodeAttrs={getMentionNodeAttrs}
      initialItems={getInitialItems(initailMentions)}
      type={view}
      useSearch={useSearch}
    />
  );
}

export default Mentions;
